import {xhr} from 'brave-utils/xhr'


export const baseUrl = (process.env.NODE_ENV == 'production' || process.env.APP_ENV == 'staging')
  ? document.location.origin
  : 'https://bravenet.com'

export async function call(method, url, payload, options = {}) {
  let data = {status: "ERROR"}
  let dataRaw = null
  try {
    dataRaw = await xhr(method, url, payload, options)
  } catch (e) {
    data.response = {reason: "UNEXPECTED", errorDetails: e}
  }
  if (dataRaw) {
    try {
      data = JSON.parse(dataRaw.response)
    } catch (e) {
      if (dataRaw.response && dataRaw.response === 'success') {
        data = {status: 'success'}
      } else {
        data.response = {reason: "UNEXPECTED", errorDetails: e}
      }
    }
  }
  return data
}

